import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom';
import { getDefaultStock, getStock, getStockHowto, getStockSeason, getRelativeRate, getFinancialStatements } from 'Request/stock';
import { setTicker as setTickerStore, setTickerDetail, setHowto, setSeason, setRelativeRate, setFinancialStatements } from 'Reducers/stock';

const Stock = () => {

  const [searchParams] = useSearchParams();
  const { type, typ, financialState } = useSelector((state) => state.stock);
  const [ticker, setTicker] = useState();
  const [tickerInfo, setTickerInfo] = useState();
  const dispatch = useDispatch();

  /* 이벤트 시작 */

  useEffect(() => {
    console.log("searchParams useEffect 호출됨.");
    let code = '';
    if (searchParams) {
      if (searchParams.get("ticker")) {
        code = searchParams.get("ticker");
        setTicker(code);
        // keep store in sync so pages can read ticker
        dispatch(setTickerStore(code));
      }
    }

    if (code === '') {
      getDefaultStock().then(res => {
        if (res.code === "0000") {
          setTicker(res.data);
          dispatch(setTickerStore(res.data));
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }, [searchParams, dispatch]);
  
  useEffect(() => {
    if (ticker) {
      console.log("ticker useEffect 호출됨.", ticker);
      getStock(ticker).then(res => {
        if (res.code === "0000") {
          console.log("getStock", res.data);
          dispatch(setTickerDetail(res.data));
          setTickerInfo({
            ctrTyp: res.data.CTR_TYP,
            stkTyp: res.data.STK_TYP,
            ticker: res.data.TICKER,
            ticker_name: res.data.TICKER_NAME
          })
        } else {
          // API responded but no data for ticker -> explicitly mark as loaded with null
          console.log("getStock: no data for ticker", res);
          dispatch(setTickerDetail(null));
          setTickerInfo(null);
        }
      }).catch(e => {
        console.log(e)
        // network / server error -> mark as attempted load so EmptyStock can show
        dispatch(setTickerDetail(null));
      })
    }
  }, [ticker, dispatch]);

  useEffect(() => {
    if (tickerInfo && type) {
      console.log("tickerInfo, type useEffect 호출됨.", tickerInfo, type);
      const params = {
        ticker: tickerInfo.ticker,
        type: type.value,
        ctrTyp: tickerInfo.ctrTyp
      }
      getStockHowto(params).then(res => {
        if (res.code === "0000") {
          console.log("getStockHowto", res.data);
          dispatch(setHowto(res.data));
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }, [tickerInfo, type, dispatch]);

  useEffect(() => {
    if (tickerInfo && typ) {
      console.log("tickerInfo, typ useEffect 호출됨.", tickerInfo, typ);
      const params = {
        ticker: tickerInfo.ticker,
        typ: typ.value,
        ctrTyp: tickerInfo.ctrTyp
      }
      getStockSeason(params).then(res => {
        if (res.code === "0000") {
          console.log("getStockSeason", res.data);
          dispatch(setSeason(res.data));
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }, [tickerInfo, typ, dispatch]);

  useEffect(() => {
    console.log('relativeRate useEffect 호출됨.', ticker);
    if (ticker) {
      // 시장대비 상대수익률
      getRelativeRate(ticker).then(res => {
        if (res.code === "0000") {
          console.log("getRelativeRate", res.data);
          dispatch(setRelativeRate(res.data));
        }
      }).catch(e => {
        console.log(e);
      })
    }
  }, [ticker, dispatch]);

  useEffect(() => {
    console.log('financialStatements useEffect 호출됨.', ticker, financialState);
    if (ticker && financialState) {
      const params = {
        ticker: ticker,
        item: financialState
      }
      // 주요 재무제표 추이
      getFinancialStatements(params).then(res => {
        if (res.code === "0000") {
          console.log("getFinancialStatements", res.data);
          dispatch(setFinancialStatements(res.data));
        }
      }).catch(e => {
        console.log(e);
      })
    }
  }, [ticker, financialState, dispatch]);
  /* 이벤트 종료 */
}

export default Stock;
